import { Button } from '@/views/component/ui-template/Button';
import { Text } from '@/views/component/ui-template/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
  from {
    opacity: 0;
    margin-top: -5rem;
  }
  to {
    opacity: 1;
    margin-top: 0rem;
  }
`;

const Wrapper = styled.div`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.login.background};
`;

const WarpperContent = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 150px 0 60px 0;
  border-radius: 10px;
  animation: 1s ease-in-out 0s 1 ${slideDown};
`;

const Logo = styled.img`
  position: absolute;
  width: 100%;
  top: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.3));
`;

const WarpperButton = styled.div`
  width: 200px;
  display: block;
  margin: 50px auto 0 auto;
`;

function PageNotFoundComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Wrapper>
      <WarpperContent>
        <Logo src="/assets/images/common/Working.svg" alt="" />
        <Text $textAlign="center" $size="title" $inverse>
          {t('404_PAGE')}
        </Text>
        <WarpperButton>
          <Button
            $color="primary"
            type="submit"
            onClick={() => navigate('/')}
            $fullWidth
          >
            {t('BACK')}
          </Button>
        </WarpperButton>
      </WarpperContent>
    </Wrapper>
  );
}

export default PageNotFoundComponent;
